import styled from "styled-components";
import { colors, spacing, textStyles, toCSS } from "design-system/foundation";

export type ChipVariant = "question" | "hint" | "info" | "correct" | "wrong";

const getChipColors = (variant: ChipVariant) => {
  switch (variant) {
    case "question":
      return `color: ${colors.text.semantic.warning}; background: ${colors.bg.warning.primarySoft};`;
    case "hint":
      return `color: ${colors.text.semantic.brand}; background: ${colors.bg.information.primarySoft};`;
    case "info":
      return `color: ${colors.text.base.secondary}; background: ${colors.bg.base.disabled};`;
    case "correct":
      return `color: ${colors.text.semantic.success}; background: ${colors.bg.success.primarySoft};`;
    case "wrong":
      return `color: ${colors.text.semantic.error}; background: ${colors.bg.error.primarySoft};`;
  }
};

const getChipIconColor = (variant: ChipVariant) => {
  switch (variant) {
    case "question":
      return colors.icon.semantic.warning;
    case "hint":
      return colors.icon.semantic.brand;
    case "info":
      return colors.icon.base.secondary;
    case "correct":
      return colors.icon.semantic.success;
    case "wrong":
      return colors.icon.semantic.error;
  }
};

export const ChipWrapper = styled.div<{ $variant: ChipVariant }>`
  &,
  & *,
  & *::before,
  & *::after {
    box-sizing: border-box;
  }

  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${spacing.md};
  padding: ${spacing.xs} ${spacing.xl};
  border-radius: 100px;
  ${({ $variant }) => getChipColors($variant)}
  ${toCSS(textStyles.body.body5Bold)}

  .icon {
    display: flex;
    align-items: center;
    color: ${({ $variant }) => getChipIconColor($variant)};
    font-size: ${textStyles.body.body5Bold.lineHeight};
  }
`;

export const ChipText = styled.p`
  margin: ${spacing.none};
  color: inherit;
  line-height: 1;
`;
